var map = {
	"./man_glove_1.png": "B2Oi",
	"./man_glove_2.png": "718Q",
	"./man_glove_3.png": "cxLE",
	"./man_glove_4.png": "H8K0",
	"./man_glove_5.png": "c7rJ",
	"./man_glove_6.png": "Biv6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "x/Sz";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/man_glove_.*\.png$
// module id = x/Sz
// module chunks = 0